import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { EmbeddedFunctionField, FunctionField, TextField } from 'shared/react-admin/Fields';
import { GatewayRule } from 'types/embedded/gatewayRule';
import { formatInputInTz } from 'utils/date';

import {
  GatewayRuleInfoFieldsStyled,
  GatewayRuleInfoFieldStyled,
  GatewayRuleInfoLabelStyled,
  GatewayRuleInfoMerchantFieldStyled,
  GatewayRuleInfoNameStyled,
  GatewayRuleInfoWrapperStyled,
} from './GatewayRuleInfo.styled';

export function GatewayRuleInfo() {
  const translate = useTypedTranslate();
  const { hasResourceAccess } = usePermissions();

  return (
    <GatewayRuleInfoWrapperStyled>
      <GatewayRuleInfoNameStyled>
        <EmbeddedFunctionField
          cellClassName="column-name"
          linkConfig={{
            resource: Resources.GatewayRules,
            idField: '@id',
          }}
          sourceField="name"
          sx={{ fontSize: '18px' }}
        />
      </GatewayRuleInfoNameStyled>
      <GatewayRuleInfoFieldsStyled>
        <GatewayRuleInfoFieldStyled>
          <GatewayRuleInfoLabelStyled>ID:</GatewayRuleInfoLabelStyled>
          <TextField fontSize="14px" source="originId" />
        </GatewayRuleInfoFieldStyled>
        <GatewayRuleInfoMerchantFieldStyled>
          <GatewayRuleInfoLabelStyled>
            {`${translate('app.table.merchant')}:`}
          </GatewayRuleInfoLabelStyled>
          {hasResourceAccess('merchants') && (
            <EmbeddedFunctionField
              linkConfig={{
                resource: 'merchants',
                idField: 'merchant.@id',
              }}
              sortBy="merchant.name"
              sourceField="merchant.name"
            />
          )}
        </GatewayRuleInfoMerchantFieldStyled>
        <GatewayRuleInfoFieldStyled>
          <GatewayRuleInfoLabelStyled>
            {`${translate('app.table.createdAt')}:`}
          </GatewayRuleInfoLabelStyled>
          <FunctionField
            render={(record: GatewayRule) =>
              formatInputInTz(record?.createdAt, { format: 'dd.MM.yyyy, HH:mm' })
            }
          />
        </GatewayRuleInfoFieldStyled>
        <GatewayRuleInfoFieldStyled>
          <GatewayRuleInfoLabelStyled>
            {`${translate('app.table.updatedAt')}:`}
          </GatewayRuleInfoLabelStyled>
          <FunctionField
            render={(record: GatewayRule) =>
              formatInputInTz(record?.updatedAt, { format: 'dd.MM.yyyy, HH:mm' })
            }
          />
        </GatewayRuleInfoFieldStyled>
      </GatewayRuleInfoFieldsStyled>
    </GatewayRuleInfoWrapperStyled>
  );
}
